module.exports = __webpack_public_path__ + "static/img/联想ThinkPad X1 Carbon Gen 13.bb793bb4.png";